// extracted by mini-css-extract-plugin
export default {"tariffs":"RFccL","tariff":"lGUDj","tariffsCount":"HRaax","addTariff":"in6Pa","addExcludedCountriesButton":"_Cghj","field":"xRnfq"};